import styles from './Ada.module.scss'

const AdaVideoInTxt = () => <div className={styles['video-ad']} id="sc_intxt" data-adformat="sc_intxt"></div>

export default AdaVideoInTxt
